var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProhibit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.875A8.125 8.125 0 1018.125 10 8.133 8.133 0 0010 1.875zM16.875 10a6.84 6.84 0 01-1.595 4.397L5.604 4.719A6.875 6.875 0 0116.875 10zm-13.75 0A6.84 6.84 0 014.72 5.603l9.677 9.678A6.874 6.874 0 013.125 10z",
    fill: "#3A3544"
  })));
}

export default SvgProhibit;